module.exports = __webpack_public_path__ + "static/media/img106.b5bc5652.png";